export const images = [
  { id: 1, original: "/images/services/2/sub-categories/2/c2-s2-p1.jpg" },
];
